module.exports = __webpack_public_path__ + "static/image-d5fa4ca3d663ffd55f0cb7eecc88fecf.jpg";